/*
@param {object} - { articleCode: array, apiBaseUrl: string, locale: String }
@return {HTMLElement | null} - HTML containing the QuickShop content from Appeaser
*/
import { __awaiter } from "tslib";
import { getLocale } from '../locale';
const getQuickShopProduct = ({ articleCodes, apiBaseUrl, locale, quickBuyLink, }) => __awaiter(void 0, void 0, void 0, function* () {
    if (articleCodes.length === 0) {
        return null;
    }
    const articleCode = articleCodes.map((code) => `${code}`).join('&');
    const trimmedApiBaseUrl = apiBaseUrl === null || apiBaseUrl === void 0 ? void 0 : apiBaseUrl.replace(/\/+$/, '');
    const base = trimmedApiBaseUrl ? `${trimmedApiBaseUrl}/${locale || getLocale()}` : '';
    const url = quickBuyLink ||
        `${base}/productpage/_jcr_content/product.quickbuy.${articleCode}.html?format=html`;
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'text/html' },
    };
    const response = yield fetch(url, requestOptions);
    const htmlContent = yield response.text();
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlContent, 'text/html');
    const praWrapper = doc.getElementById('praWrapper');
    return praWrapper;
});
export default getQuickShopProduct;
//# sourceMappingURL=getQuickShopProduct.js.map